import { HeaderModel } from './header/header.model'

// Header
export var headerModel = new HeaderModel()
export * from './header/header.view'

// Deco
export * from './decoration/decoration.view'

// Emoticon
export * from './emoticon/emoticon.view'

// Items
export * from './items/items.view'

// Class
export * from './poker-class/pokerClass.view'

/** Hot Deal */
export * from './hotdeal/hotDeal.view'

/** Gacha */
export * from './gacha/gacha.view'

// loading
export * from './loading/loading.view'

// Popup
export * from './popup/popup.model'
export * from './popup/popup.view'

export * from './pay/pay.model'
export * from './pay/pay.view'
